import { useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { RadioButton } from 'primereact/radiobutton'

import { COLOR_THEMES } from '@aytm/app/stats/page/sidebar/color-options/lib/constants'

import style from '@aytm/app/stats/page/sidebar/color-options/styles/ColorOptionsPanel.module.scss'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

// FR-CLR-UI-20..24: fixed 8-palette catalogue.
// Each COLOR_THEMES[i] is a pre-baked 21-slot HSL expansion; first 7 are the base palette.
// "copy" is a discoverability nudge — hidden once the team reaches the seven-palette cap.
const ColorThemes = ({ colorTheme, palettes, isAdmin, isSurveyOwner, disabled, onSelect, onPaletteAdd }) => {
  const copyAvailable = useMemo(
    () => 7 > palettes.length && (isAdmin || isSurveyOwner) && !disabled,
    [palettes, isAdmin, isSurveyOwner, disabled]
  )

  const handleSelect = index => onSelect(index, null)

  const handleCopy = index =>
    onPaletteAdd({
      colors: COLOR_THEMES[index].slice(0, 7),
      saturation: 10,
      luminosity: 15
    })

  return (
    <div className={style.section}>
      {COLOR_THEMES.map((theme, index) => (
        <div key={`color-theme-${index}`} className={style['palettes-item']}>
          <RadioButton
            data-testid={`stat-color-options-theme-select-${index}`}
            className="p-radiobutton-sm"
            aria-label={`Default palette ${index + 1}`}
            checked={null !== colorTheme && colorTheme === index}
            disabled={disabled}
            onChange={disabled ? null : () => handleSelect(index)}
          />
          <div
            className={classNames(style['palettes-item-colors'], { 'p-disabled': disabled })}
            onClick={disabled ? null : () => handleSelect(index)}
          >
            {theme.slice(0, 7).map((color, slotIndex) => (
              <span
                key={`color-theme-${index}-slot-${slotIndex}`}
                className={style['palettes-item-colors-item']}
                style={{ backgroundColor: color }}
              />
            ))}
          </div>
          {copyAvailable ? (
            <span
              data-testid={`stat-color-options-theme-copy-${index}`}
              className={style['palettes-item-copy']}
              {...pressable(() => handleCopy(index))}
            >
              copy
            </span>
          ) : null}
        </div>
      ))}
    </div>
  )
}

ColorThemes.propTypes = {
  colorTheme: PropTypes.number,
  palettes: PropTypes.array,
  isAdmin: PropTypes.bool,
  isSurveyOwner: PropTypes.bool,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  onPaletteAdd: PropTypes.func
}

ColorThemes.displayName = 'ColorThemes'

export default ColorThemes
